<app-header [loginInput]="login"></app-header>
<div class="d-flex">
  <app-aside></app-aside>
  <div class="flex-grow-1">
    <lib-base-page>
      <div class="h-100">
        <div class="d-flex" role="main">
          <div>
            <div class="ms-container">
              <div class="row gx-5 justify-content-start p-5 ps-4 pt-3 m-0">
                <div class="px-4 py-3 mst-2">
                  <div class="d-flex py-2">
                    <it-spinner></it-spinner><h5 class="ps-3">Caricamento in corso</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </lib-base-page>
  </div>  
</div>
